import React, { useState, useEffect } from 'react';
import {
    Link,
    useLocation,
    useHistory
} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import { useForm } from "react-hook-form";
import { promoCodeAdded, promoCodeSelector } from '../../../../store/reducers/promoCodeReducer';
import { pathAdded } from '../../../../store/reducers/pathsReducer';
import { classAddedMobile, scrollMobileSelector } from '../../../../store/reducers/scrollMobileReducer';
import ErrorMessage from './error/ErrorMessage';

function PromotionCode() { 
    const promoCode = useSelector(promoCodeSelector);
    const scroll = useSelector(scrollMobileSelector);
    const dispatch = useDispatch();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const summary = params?.get("summary");
    const [scrollClass, setScrollClass] = useState(scroll);
    const [promotionCode, setPromotionCode] = useState(promoCode.code);
    const { register, handleSubmit, formState: { errors }} = useForm();
    let history = useHistory();
    const [fromSummary, setfromSummary] = useState(false);
    
    useEffect(() => {
        setPromotionCode(promoCode.code);
        window.scrollTo(0, 0);
        if(summary) {
            setfromSummary(summary);
        }
    }, []);  // eslint-disable-line
    
    useEffect(() => {
        setTimeout(function(){ setScrollClass("progression_container small") ; }, 10);
    }, []); // eslint-disable-line

    function onSubmit(data, event) {
        dispatch(pathAdded(history.location.pathname));
        dispatch(promoCodeAdded(data.promoCode));
        dispatch(classAddedMobile("progression_container small startBottom"));
        history.push("/form/summary");    
    };

    function setClass() {
        dispatch(classAddedMobile("progression_container small startTop"))
    };

    return (              
        <div className={scrollClass}>
            <h2>Nomination code</h2> 
                <div className="promoCodeSmall">
                    <p>Please enter the code you received from your client. This code is used to identify the company who will request the assessment:</p>
                    <br/>
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-group form-promoCodeSmall">
                        <label htmlFor="promoCode">code</label>
                        <input type="text" name="promoCode" defaultValue={promotionCode} placeholder="Enter your code"
                            {...register("promoCode", {
                                required: "Nomination code is required",
                                minLength: {
                                    value: 4,
                                    message: "Code must be longer than 3"
                                }
                            })} 
                        />
                        {errors.promoCode && <ErrorMessage>{errors.promoCode.message}</ErrorMessage>}
                    </div>
                    <div className="button_container">
                        {!fromSummary ? 
                            <Link to="/form/secondary" onClick={setClass} className="previous"><span>
                                <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.0815 6.5201L8.27352 8.3281L7.52152 9.0961C6.92952 9.6881 6.30552 10.3121 5.64952 11.0001H7.77752C8.92952 9.8001 11.3615 7.1441 12.7215 5.7841C11.3775 4.4401 8.94552 1.8001 7.77752 0.600098H5.64952C6.30552 1.2881 6.92952 1.9121 7.52152 2.5041L8.27352 3.2721L8.99352 4.0081C9.45752 4.4561 9.84152 4.8721 10.0815 5.0801H0.561523V6.5201H10.0815Z" fill="white"></path>
                                </svg>
                            </span> Previous</Link>                
                            : 
                                <button className="summaryNavButton" type="submit">Back to summary</button> 
                        }

                        <button type="submit" onClick={() => window.plausible('Registration Promo Code')} className="nextSubmit next"><span>Next</span>
                            <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.0815 6.5201L8.27352 8.3281L7.52152 9.0961C6.92952 9.6881 6.30552 10.3121 5.64952 11.0001H7.77752C8.92952 9.8001 11.3615 7.1441 12.7215 5.7841C11.3775 4.4401 8.94552 1.8001 7.77752 0.600098H5.64952C6.30552 1.2881 6.92952 1.9121 7.52152 2.5041L8.27352 3.2721L8.99352 4.0081C9.45752 4.4561 9.84152 4.8721 10.0815 5.0801H0.561523V6.5201H10.0815Z" fill="white"></path>
                            </svg>
                        </button>
                    </div>
                </form>
        </div>
    );
}

export default PromotionCode;
